<template>
  <!-- naniwa -->
  <div class="voice_col_wrap top slider_voice">
    <div class="voice_col" v-for="item in items" :key="item.id">
      <dl class="voice_info_box">
        <dt class="thumb" v-if="getThumb">
          <img v-if="item.thumbnail" :src="item.thumbnail" />
          <img v-else :src="noImage" alt="no image" />
        </dt>
        <dd class="position">{{ item.title.rendered }}</dd>
      </dl>
      <div class="voice_cont_box">
        <div class="content" v-html="strReplace(item.content.rendered)"></div>
        <div class="btn_wrap">
          <div class="modal_open_btn" :data-target="`modal_${item.id}`">
            続きを見る
          </div>
        </div>
      </div>

      <!-- モーダル本体 -->
      <div :id="`modal_${item.id}`" class="modal_wrapper">
        <div class="modal_container">
          <div class="modal_inner">
            <div class="modal_content">
              <div class="modal_close_btn">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path
                    d="M23.2 3.6L3.4 23.4L0.6 20.6L20.4 0.8L23.2 3.6Z"
                    fill="white"
                  />
                  <path
                    d="M20.6 23.2L0.8 3.4L3.6 0.6L23.4 20.4L20.6 23.2Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="modal_body">
                <dl class="voice_info_box">
                  <dt class="thumb">
                    <img v-if="item.thumbnail" :src="item.thumbnail" />
                    <img v-else :src="noImage" alt="no image" />
                  </dt>
                  <dd class="position">{{ item.title.rendered }}</dd>
                </dl>
                <div
                  class="scroll_content"
                  v-html="item.content.rendered"
                ></div>
              </div>
            </div>
          </div>
          <div class="modal_overlay"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
      isLoading: false,
      activeModalIndex: null,
    };
  },
  watch: {
    items() {
      this.$nextTick(() => {
        const $slider = $(".slider_voice");

        // slick初期化前に解除
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }

        // 画像読み込みを待ってからslick初期化
        const images = this.$el.querySelectorAll(".slider_voice img");
        const promises = Array.from(images).map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
                img.onload = img.onerror = resolve;
              })
        );

        Promise.all(promises).then(() => {
          $slider.slick({
            slidesToShow: 4,
            infinite: false,
            slidesToScroll: 2,
            dots: true,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
            ],
          });

          // モーダル要素の移動もここで
          $(".slider_voice .modal_wrapper").each(function () {
            $(this).appendTo("body");
          });
        });
      });
    },
  },
  props: {
    url: String,
    dateformat: String,
    feedstyle: {
      type: String,
      default: "blog",
    },
    getThumb: {
      type: Boolean,
      default: false,
    },
    thumbSize: {
      type: String,
      default: "thumbnail",
    },
    getExcerpt: {
      type: Boolean,
      default: false,
    },
    getDate: {
      type: Boolean,
      default: true,
    },
    flameType: {
      type: String,
      default: "A",
    },
    childClass: {
      type: String,
      default: "",
    },
    h3Class: {
      type: String,
      default: "",
    },
    noImage: {
      type: String,
      default: "/assets/img/common/no_image.png",
    },
  },
  methods: {
    getPosts() {
      this.isLoading = true;
      var self = this;
      axios
        .get(this.url)
        // Success
        .then((response) => {
          if (response.status != 200) {
            console.log(response.statusText);
            exit;
          }
          self.items = response.data;
          //サムネイルの取得とデータ格納
          if (self.getThumb) {
            for (let i = 0; i < self.items.length; i++) {
              if (response.data[i]["_embedded"] != "undefined") {
                const target =
                  "_embedded.wp:featuredmedia.0.media_details.sizes." +
                  self.thumbSize +
                  ".source_url";
                if (this.objectLookUp(response.data[i], target)) {
                  if (
                    response.data[i]["_embedded"]["wp:featuredmedia"][0][
                      "media_details"
                    ]["sizes"][self.thumbSize]["source_url"]
                  ) {
                    self.items[i].thumbnail =
                      response.data[i]["_embedded"]["wp:featuredmedia"][0][
                        "media_details"
                      ]["sizes"][self.thumbSize]["source_url"];
                  }
                }
              }
            }
          }
          this.isLoading = false;
        })
        // Error
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    dateConv(data) {
      var newdate = new Date(data);
      var year = newdate.getFullYear();
      var month = newdate.getMonth() + 1;
      var day = newdate.getDate();

      if (this.dateformat == "dots") {
        // dots の場合のみゼロ埋め
        month = month.toString().padStart(2, "0");
        day = day.toString().padStart(2, "0");
        return year + "." + month + "." + day;
      } else {
        return year + "年" + month + "月" + day + "日";
      }
    },
    strReplace(data) {
      //…[&hellip;]
      var replaced = data.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
      replaced = replaced.replace(/ \[&hellip;\]/g, "…");
      //console.log(replaced);
      return replaced;
    },
    objectLookUp(obj, path) {
      const keys = path.split(".");
      for (let k in keys) {
        const key = keys[k];

        if (!obj.hasOwnProperty(key)) {
          return false;
        }

        if (keys.length > 1) {
          return this.objectLookUp(obj[key], keys.splice(1).join("."));
        }
        return true;
      }
    },
    getTaxonomyTerms(item) {
      if (
        item._embedded &&
        item._embedded["wp:term"] &&
        item._embedded["wp:term"][0] &&
        item._embedded["wp:term"][0].length > 0
      ) {
        // "column-cat" タクソノミーのすべてのタームを配列で返す
        return item._embedded["wp:term"][0]
          .filter((t) => t.taxonomy === "column-cat")
          .map((t) => t.name);
      }
      return []; // タームがない場合は空配列
    },
    openModal(index) {
      this.activeModalIndex = index;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.activeModalIndex = null;
      document.body.style.overflow = "";
    },
  },
  created() {
    this.getPosts();
  },
};
</script>